jQuery(document).ready(function ($) {
    $( document.body ).on( 'updated_cart_totals', function(){
        if ($('.woocommerce-notices-wrapper').length > 0) {
            setTimeout(function() {
                var scroll_pos = $('.woocommerce-notices-wrapper').first().offset().top - $('#header').outerHeight() - 15;
                if (scroll_pos < 0) {
                    scroll_pos = 0;
                }
                $('html, body').animate({
                    scrollTop: scroll_pos
                }, 400);
            }, 400);
        }
    });
});
